// extracted by mini-css-extract-plugin
export default {"list":"SocialNetworkNav_list__jAPO-","anchor":"SocialNetworkNav_anchor__+-tlJ","icon":"SocialNetworkNav_icon__llbyp","customIcon":"SocialNetworkNav_customIcon__oTYuH"};